export const RoleTypes = {
    CompanyAdmin: "CompanyAdmin",
    CompanyUserShiftLeader: "CompanyUserShiftLeader",
    CompanyUserVeterinarian: "CompanyUserVeterinarian",
    SuperAdmin: "SuperAdmin"
}


// WEBPACK FOOTER //
// ./src/constants/role_types.js